import { GitBranch } from "@phosphor-icons/react";
import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader, StatusChip } from "./primitives";

const Interoperability = () => {
  const config = useSiteConfig();
  return (
    <section className="relative py-24 lg:py-32 border-t border-line" data-testid="interoperability-section">
      <div className="section-shell grid gap-12 lg:grid-cols-2 lg:gap-20 items-start">
        <div>
          <SectionHeader
            index={13}
            eyebrow="Interoperability"
            title={<>Born on BNB Chain.<br />Built for a Multi-Chain Future.</>}
            sub="JCV launches on BNB Smart Chain while maintaining an architecture designed with future interoperability in mind."
            testId="interoperability-header"
          />
          <Reveal delay={0.15} className="mt-8">
            <StatusChip tone="gold" testId="interoperability-status">{config.interoperability.status}</StatusChip>
          </Reveal>
        </div>
        <div className="space-y-3">
          {config.interoperability.items.map((item, i) => (
            <Reveal key={item} delay={i * 0.07} y={16} testId={`interop-item-${i}`}>
              <div className="card-surface flex items-center gap-4 rounded-lg px-6 py-5">
                <GitBranch size={20} className="text-teal shrink-0" aria-hidden="true" />
                <span className="text-sm sm:text-base text-mist">{item}</span>
                <span className="ml-auto font-mono text-[10px] tracking-[0.2em] uppercase text-slate shrink-0">Future</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Interoperability;
